import React from 'react';
import Select from 'react-select';
import cx from 'classnames';
import { dropdownTypes } from '../Reports/values/enums'
import cloneDeep from 'lodash.clonedeep';

// TODO extend this component to support both primary and secondary selection styles
class Dropdown extends React.Component {
  constructor(props){
    super(props);
  }

  render() {
    let primaryDropdown = false;
    if(this.props.type === dropdownTypes.PRIMARY) {
      primaryDropdown = true;
    }

    const dropdownStyle = cx({
      "teacherDisabledSelect": this.props.isDisabled,
      "teacherSecondarySelect": !primaryDropdown,
      "teacherPrimarySelect": primaryDropdown,
    });

    const dropdownPrefixStyle = cx({
      "teacherDisabledSelect": this.props.isDisabled,
      "teacherSecondarySelect": !this.props.isDisabled && !primaryDropdown,
      "teacherPrimarySelect": !this.props.isDisabled && primaryDropdown,
    });

    // ensure label of selected value matches option labels
    const value = cloneDeep(this.props.value);
    const selectedOption = this.props.options.find(option => option.value === value?.value);
    if (selectedOption) value.label = selectedOption.label;

    return (
      <Select
        menuPlacement="auto"
        isSearchable={false}
        className={dropdownStyle}
        classNamePrefix={dropdownPrefixStyle}
        value={value}
        onChange={this.props.onChange}
        options={this.props.options}
        placeholder={this.props.placeholder}
        isDisabled={this.props.isLoading}
      />
    );
  }
}

Dropdown.defaultProps = {
  type: dropdownTypes.SECONDARY,
  placeholder: '',
  isDisabled: false,
  value: null,
  options: [],
}

export default Dropdown;